import { heroChips } from "@/mocks/portal";

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden">
      <div className="pointer-events-none absolute -right-24 -top-24 h-80 w-80 rounded-full bg-primary-100/60 blur-3xl" aria-hidden="true" />
      <div className="pointer-events-none absolute -left-20 top-40 h-72 w-72 rounded-full bg-accent-100/50 blur-3xl" aria-hidden="true" />

      <div className="mx-auto grid max-w-[1200px] gap-8 px-4 py-10 md:px-6 md:py-16 lg:grid-cols-[1.05fr_0.95fr] lg:gap-12 lg:py-20">
        {/* 文列 */}
        <div className="relative flex flex-col justify-center">
          <div className="mb-4 flex flex-wrap items-center gap-2">
            <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-700">
              <i className="ri-fire-line text-[13px]" aria-hidden="true" />
              今日在线参考
            </span>
            <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-100 px-3 py-1 text-xs font-semibold text-primary-700">
              <i className="ri-time-line text-[13px]" aria-hidden="true" />
              本周样本已刷新
            </span>
          </div>

          <h1 className="text-2xl font-extrabold leading-snug text-foreground-950 md:text-4xl">
            吃瓜线路
            <span className="mx-2 text-primary-500">切换指南</span>
            <br className="hidden md:block" />
            把「哪个好用」变成看得见的数据
          </h1>

          <p className="mt-4 max-w-xl text-sm leading-7 text-foreground-600 md:text-base md:leading-8">
            面向不同网络环境的参考站：聚合<b className="font-semibold text-foreground-800">线路对比</b>与<b className="font-semibold text-foreground-800">速度测试</b>样本，
            帮你在
            <b className="font-semibold text-primary-600">多线选择</b>时快速判断——晚高峰该切哪条、跨境该走哪条、
            换线会不会断，看完这篇就有底。
          </p>

          <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#compare"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              开始线路对比
              <i className="ri-arrow-right-line text-base" aria-hidden="true" />
            </a>
            <a
              href="#guide"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-6 py-3 text-sm font-semibold text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              <i className="ri-book-open-line text-base" aria-hidden="true" />
              看切换指南
            </a>
          </div>

          <dl className="mt-8 grid grid-cols-3 gap-3 border-t border-background-200 pt-5 sm:max-w-md">
            {heroChips.map((c) => (
              <div key={c.label}>
                <dt className="text-[11px] text-foreground-500">{c.label}</dt>
                <dd className="font-num mt-1 text-lg font-bold text-foreground-950">{c.value}</dd>
              </div>
            ))}
          </dl>
        </div>

        {/* 图列 */}
        <div className="relative">
          <div className="overflow-hidden rounded-2xl border border-background-200 bg-background-100">
            <img
              src="https://readdy.ai/api/search-image?query=Minimal%20editorial%203D%20illustration%20of%20an%20interconnected%20network%20map%20made%20of%20clean%20geometric%20nodes%20and%20thin%20route%20arcs%20between%20city%20markers%2C%20fresh%20green%20main%20nodes%20with%20a%20few%20warm%20muted%20red%20hotspots%20and%20white%20empty%20space%2C%20warm%20cream%20paper%20background%2C%20soft%20rounded%20shapes%2C%20layered%20depth%2C%20gentle%20shadows%2C%20calm%20technical%20aesthetic%2C%20high%20detail&width=900&height=1000&seq=chigua-hero-cover-1&orientation=portrait"
              alt="吃瓜线路多线选择参考图"
              title="吃瓜线路 多线选择 参考"
              className="h-72 w-full object-cover object-top md:h-[440px] lg:h-[520px]"
            />
          </div>

          <div className="absolute left-3 top-3 flex items-center gap-2 rounded-full bg-background-50/90 px-3 py-1.5 text-xs font-medium text-foreground-700 backdrop-blur md:left-4 md:top-4">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-primary-500 opacity-60" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-primary-500" />
            </span>
            全国干线 运行正常
          </div>

          <div className="absolute bottom-3 right-3 flex items-center gap-2.5 rounded-2xl bg-background-50/95 px-4 py-3 backdrop-blur md:bottom-4 md:right-4">
            <span className="font-num grid h-10 w-10 place-items-center rounded-xl bg-accent-100 text-accent-600">
              <i className="ri-flashlight-line text-xl" aria-hidden="true" />
            </span>
            <div>
              <p className="text-[11px] text-foreground-500">当前最优延迟</p>
              <p className="font-num text-base font-bold text-foreground-950">18 ms</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}